
.root {
    composes: root from "TerritoryCard.module.css";
    grid-template-areas:
            "minimap header header number"
            "map map map map"
            "footer footer footer footer";
}

.header {
    composes: header from "TerritoryCard.module.css";
}

.title {
    composes: title from "TerritoryCard.module.css";
}

.region {
    composes: region from "TerritoryCard.module.css";
}

.number {
    composes: number from "TerritoryCard.module.css";
}

.minimap {
    composes: minimap from "TerritoryCard.module.css";
}

.map {
    composes: map from "TerritoryCard.module.css";
}

.addresses {
    composes: addresses from "TerritoryCard.module.css";
}

.footer {
    composes: footer from "TerritoryCard.module.css";
}

.qrCode {
    /* position on top of the map, bottom-right corner */
    grid-area: map;
    z-index: 1;
    justify-self: end;
    align-self: end;
    width: var(--qr-code-size);
    height: var(--qr-code-size);

    /* avoid overlapping the map attribution */
    --map-attribution-height: 11px;
    --qr-code-margin: 0.5mm;
    margin-bottom: calc(var(--map-attribution-height) + var(--qr-code-margin));
    margin-right: var(--qr-code-margin);
    border: 2px solid white;
}
